import $ from "jquery";
/* eslint-disable */
window.$ = $;
window.jQuery = $;

import "moment/locale/ru";
import Datepicker from "./module/Datepicker";
document
    .querySelectorAll(".js-dates")
    .forEach((element) => new Datepicker(element));

import "jquery-mask-plugin";
import "jquery-serializejson";
import "./lib/input-validation-html5";
import "./lib/jquery.serialize-object";
import "./lib/jquery.reel";
import "./lib/placeholder-shown";

import "./module/about-history";
import "./module/about-news-slider";
import "./module/about-production";
import "./module/about-values";
import "./module/about-video";
import "./module/annotation-text-hover";
import "./module/accordion--simple";
import "./module/another-articles-slider";
import "./module/auth-bonus-page";
import "./module/blog";
import "./module/business-video";
import "./module/business-slider";
import "./module/cashback-tooltip";
import "./module/cashback-amount";
import "./module/cashback-order-spend";
import "./module/catalog";
import "./module/catalog-detail-documents";
import "./module/catalog-detail-links";
import "./module/catalog-detail-faq";
import "./module/catalog-detail-gallery";
import "./module/catalog-detail-gallery-lens";
import "./module/catalog-detail-purchase";
import "./module/catalog-detail-quantity";
import "./module/catalog-detail-showreel";
import "./module/catalog-detail-subscribe";
import "./module/catalog-linked";
import "./module/content-tabs-detail-text";
import "./module/catalog-not-medicine";
import "./module/consult";
import "./module/content-tabs";
import "./module/control-checkbox";
import "./module/control-file";
import "./module/control-input";
import "./module/control-select";
import "./module/cookie-notice";
import "./module/documents";
import "./module/faq";
import "./module/filter";
import "./module/footer-subscribe";
import "./module/header-language";
import "./module/index-about";
import "./module/index-blog";
import "./module/index-catalog";
import "./module/index-partnership";
import "./module/index-popular";
import "./module/index-slider";
import "./module/IsAnotherPersonOrder";
import "./module/lazyload";
import "./module/img-svg-hack";
import "./module/left-menu";
import "./module/last-page-register-cache";
import "./module/mobile-menu";
import "./module/news";
import "./module/order";
import "./module/personal";
import "./module/personal-delivery";
import "./module/personal-order";
import "./module/personal-cashback-detail";
import "./module/popup";
import "./module/popup-login";
import "./module/popup-search";
import "./module/popup-tabs";
import "./module/popup-question";
import "./module/product-slider";
import "./module/progress";
import "./module/radio-tile";
import "./module/ref-first-notification";
import "./module/ref";
import "./module/register";
import "./module/services-map";
import "./module/scroll-top";
import "./module/map-pickpoint-search";
import "./module/copy-link";
import "./module/catalog-item-to-basket";
import "./module/form-account-update";
import "./module/form-account-verify";
import "./module/form-common";
import "./module/header-city";
import "./module/header-catalog";
import "./module/header-catalog-tabs";
import "./module/header-basket";
import "./module/top-ten";
import "./module/wishlist";
import "./module/yandex-metric";

import "./ui";
import "./forms";
import "./pages";

import "./service/CheckboxService";

import { updatePrices } from "./utilities";
import { deliveryDate } from "./utilities";

setTimeout(updatePrices, 90);
//setTimeout(deliveryDate, 90);
